<template>
  <v-btn flat icon @click="edit" title="Редагувати">
    <v-icon>edit</v-icon>
  </v-btn>
</template>

<script>

export default {
  name: 'PostEditButton',
  props: {
    postId: {
      required: true,
    },
  },
  methods: {
    edit() {
      this.$router.push({ name: 'postEdit', params: { id: this.postId } });
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/components/PostEditButton.vue